import type { RouteRecordRaw } from 'vue-router';

export const registerRoutes: RouteRecordRaw[] = [
    {
        path: '/register',
        name: 'RegisterList',
        component: () => import('./views/RegisterListPage.vue'),
        meta: {
            title: 'Register List',
            titleKey: 'register.listTitle',
            requiresAuth: true,
            layout: 'default'
        }
    },
    {
        path: '/register/my',
        name: 'MyRegisterBook',
        component: () => import('./MY/views/MyRegisterBookPage.vue'),
        meta: {
            title: 'Register Book',
            titleKey: 'register.bookTitle',
            requiresAuth: true,
            layout: 'default'
        }
    },
    {
        path: '/register/current',
        name: 'CurrentRegisterBook',
        component: () => import('./current/views/CurrentRegisterEntry.vue'),
        meta: {
            title: 'Current Register',
            requiresAuth: true,
            layout: 'default',
            // local / development 환경에서만 라우트 등록
            devOnly: true,
        }
    },
    {
        path: '/register/:rgstCd',
        name: 'RegisterDetail',
        component: () => import('./views/RegisterDetailPage.vue'),
        meta: {
            title: 'Register Detail',
            titleKey: 'register.Register Detail',
            requiresAuth: true,
            layout: 'default'
        }
    },
    {
        path: '/register/new/:category?',
        name: 'RegisterNew',
        component: () => import('./views/RegisterDetailPage.vue'),
        meta: {
            title: 'New Register',
            titleKey: 'register.New Register',
            requiresAuth: true,
            layout: 'default'
        }
    }
];


